import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SocioResponse } from '../../../models/socioResponse.model';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import { descricaoIdentificacaoCpfCnpj, IdentificacaoCpfCnpj } from '../../../models/enums/identificacao-cpf-cnpj.enum';

@Component({
  selector: 'app-socios-detalhes',
  templateUrl: './socios-detalhes.component.html',
  styleUrls: ['./socios-detalhes.component.scss'],
})
export class SociosDetalhesComponent {
  @Input() socio: SocioResponse | null = null;
  @Output() close = new EventEmitter<void>();

  formatarCpfCnpj(cpfCnpj: string): string {
    return FormatadorHelper.formatarCpfCnpj(cpfCnpj);
  }

  formatarTelefone(telefone: string): string {
    return FormatadorHelper.formatarTelefone(telefone);
  }

  formatarData(data: string): string {
    if (!data) return 'Não informado';
    return new Date(data).toLocaleDateString('pt-BR');
  }

  formatarValor(valor: number | null | undefined): string {
    if (!valor) return 'Não informado';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor);
  }

  enderecoCompleto(socio: SocioResponse): string {
    const endereco = [
      socio.tpLograd,
      socio.dscLograd,
      socio.nrLograd,
      socio.complemento,
      socio.bairro,
      socio.municipio,
      socio.uf,
      socio.cep,
      socio.paisNascto
    ].filter(item => item && item.trim() !== '').join(', ');
    
    return endereco || 'Não informado';
  }

  getTipoDocumento(cpfCnpj: string): string {
    if (FormatadorHelper.ehCpf(cpfCnpj)) {
      return descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cpf];
    }

    if (FormatadorHelper.ehCnpj(cpfCnpj)) {
      return descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cnpj];
    }

    return 'Desconhecido';
  }

  getSexoDescricao(sexo: number): string {
    const sexoMap: { [key: number]: string } = {
      0: 'Não informado',
      1: 'Masculino',
      2: 'Feminino'
    };
    return sexoMap[sexo] || 'Não informado';
  }

  getEstadoCivilDescricao(estCiv: number): string {
    const estadoCivilMap: { [key: number]: string } = {
      1: 'Solteiro',
      2: 'Casado',
      3: 'Divorciado',
      4: 'Viúvo',
      5: 'União Estável'
    };
    return estadoCivilMap[estCiv] || 'Não informado';
  }

  getGrauInstrucaoDescricao(grauInstr: number): string {
    const grauInstrucaoMap: { [key: number]: string } = {
      1: 'Analfabeto',
      2: 'Até 5ª Incompleto',
      3: '5ª Completo Fundamental',
      4: '6ª a 9ª Fundamental',
      5: 'Fundamental Completo',
      6: 'Médio Incompleto',
      7: 'Médio Completo',
      8: 'Superior Incompleto',
      9: 'Superior Completo',
      10: 'Mestrado',
      11: 'Doutorado',
      12: 'Ignorado'
    };
    return grauInstrucaoMap[grauInstr] || 'Não informado';
  }

  getRacaCorDescricao(racaCor: number): string {
    const racaCorMap: { [key: number]: string } = {
      1: 'Branca',
      2: 'Negra',
      3: 'Parda',
      4: 'Amarela',
      5: 'Indígena',
      6: 'Não informado'
    };
    return racaCorMap[racaCor] || 'Não informado';
  }
  
  getNumeroDependentes(): number {
    if (!this.socio || !this.socio.dependentes) {
      return 0;
    }

    if (this.socio.numeroDependentes && this.socio.numeroDependentes > 0) {
      return this.socio.numeroDependentes;
    }

    return this.socio.dependentes.length;
  }

  closeDialog() {
    this.close.emit(); 
  }
} 
